<div class="modal-header" *ngIf="headerText">
  <h4 class="modal-title">{{ headerText }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="alert mt-3"
       role="alert"
       [ngClass]="messageAlertClass"
       [innerHTML]="messageText">
  </div>
  <div class="alert"
       role="alert"
       *ngIf="secondaryMessageText"
       [ngClass]="secondaryMessageAlertClass"
       [innerHTML]="secondaryMessageText">
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    {{ hasConfirmation ? 'Cancel' : 'Close' }}
  </button>
  <button type="button" class="btn btn-primary"
          *ngIf="hasConfirmation"
          (click)="handleConfirm()"
          [class.disabled]="confirming"
          [disabled]="confirming">
    {{ confirming ? 'Loading...' : 'Confirm' }}
  </button>
</div>
